import { validationRules } from "../../utils/validation"

export const CorporateStructureSchema = {
    certifiedStructureChart: [
        validationRules.required("Have you obtained a certified structure chart for the entity? is required"),
    ],
    outstandingConcern: [
        validationRules.required("Are there any outstanding concerns regarding the structure? is required"),
    ],
    isUbo25Identified: [
        validationRules.required("Is the entity's 25% UBO identified? is required"),
    ],
    // concernDetails:[validationRules.required("Please document your concerns in detail and notify the Money Laundering Nominated Officer (MLNO). is required"),


    // ]
}

export const certifiedStructureChartQuestion = {  
    isUboIdentified:[validationRules.required("Have the ultimate beneficial owners (UBOs) been identified and verified at Companies House or an equivalent corporate registry? is required"),


    ],

    // whyUboNotIdentified:[validationRules.required("If the UBOs have not been identified, please explain why. is required"),


    // ],
    // managedByOne:[validationRules.required("Is there one individual who ultimately exercises significant influence or control over this entity - for example, a managing director? is required"),

    // ]

}


export const oustandingdetailschema = {  
    concernDetails:[validationRules.required("Please document your concerns in detail and notify the Money Laundering Nominated Officer (MLNO). is required"),


    ]

   
}



export const isUbo25Identifiedquestion = {  
    whyUboNotIdentified:[validationRules.required("If the UBOs have not been identified, please explain why. is required"),


    ],
    managedByOne:[validationRules.required("Is there one individual who ultimately exercises significant influence or control over this entity - for example, a managing director? is required"),

    ]
}


export const lastschema = {
    threeYearUKAccount : [
        validationRules.required("Has the contracted entity filed three years or more accounts at UK Companies House? Is it a well-known UK Company or a subsidiary of a well-known company registered in the UK or another low-risk jurisdiction? is required"),
    ],

    wellKnownUKCompany : [
        validationRules.required("Is it a well-known UK Company or a subsidiary of a well-known company registered in the UK or another low-risk jurisdiction? is required"),
    ],
}